export enum InhLanguageCountryCode {
    DE = 'de',
    EN = 'en'
}

export interface InhLanguage {
    displayName: string;
    countryCode: InhLanguageCountryCode;
}

export const InhLanguages: Record<InhLanguageCountryCode, InhLanguage> = {
    [InhLanguageCountryCode.DE]: {
        displayName: $localize`deutsch`,
        countryCode: InhLanguageCountryCode.DE
    },
    [InhLanguageCountryCode.EN]: {
        displayName: $localize`english`,
        countryCode: InhLanguageCountryCode.EN
    }
};

export const AvailableLanguages: InhLanguage[] = [InhLanguages[InhLanguageCountryCode.DE], InhLanguages[InhLanguageCountryCode.EN]];

export const DefaultLanguage = InhLanguages[InhLanguageCountryCode.EN];
